import { jsx as _jsx } from "react/jsx-runtime";
import { useTestId } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { Description } from "@/components/Sections/Description/Description";
import { useAdditionalDescriptionText } from "@/components/Sections/Description";
import { useI18n } from "@/shared/hooks";
import { Section } from "@/components/UI";
export const AdditionalDescription = () => {
    const testId = useTestId("Sections.Description.AdditionalDescription");
    const { t } = useI18n();
    const { headline, text } = useAdditionalDescriptionText();
    const { additionalDescriptionRef } = useRefsContext();
    const title = t("description.block.extended.headline");
    if (!headline || !text) {
        return null;
    }
    return (_jsx(Section, { testId: testId, unsafeClassname: "Description", ref: additionalDescriptionRef, children: _jsx(Description, { testId: testId, text: text, title: title }) }));
};
